import { App } from 'vue';
export const setupGlobCom = (app: App<Element>): void => {
    const modules = import.meta.glob('./*.vue');
    Object.keys(modules).forEach((key: string) => {
        const filePathArr = key.split('/');
        const fileName = filePathArr[filePathArr.length - 1].split('.')[0];
        //@ts-ignore
        const AsyncComponent = defineAsyncComponent(modules[key]);
        app.component(fileName, AsyncComponent);
    });
};
